/**
 * ver 0.1
 * author jack
 * ex)
 */

export const AceEvent = (act, itemId, shopId, callback) => {
    let virtualPage = ''
    if (act === 'item') virtualPage = 'ace_item'
    else if (act === 'list') virtualPage = 'ace_list'
    else if (act === 'item_detail') virtualPage = 'ace_item_detail'
    else if (act === 'ad') virtualPage = 'ace_item_ad'
    else if (act === 'cart') virtualPage = 'ace_cart'
    else if (act === 'estimate') virtualPage = 'ace_estimate'
    else if (act === 'ad_estimate') virtualPage = 'ace_estimate_ad'
    else if (act === 'roulette') virtualPage = 'ace_roulette'

    if (itemId !== undefined) {
        try {
            let vp = '/'+virtualPage+'/'+itemId
            if (shopId) vp += '/'+shopId
            window._AceTM.PV(vp);
            console.info('Ace event added: '+vp)
        } catch (e) {
            console.info('Ace event error')
        }
    }
    if (callback !== undefined) callback()
}

export default AceEvent



// WEBPACK FOOTER //
// ./src/estimate_list/libs/aceEvent.js